module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slowest.90264080.svg";